const ENV = {
    GOOGLE_ANALYTICS_MEASUREMENT_ID: process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID,
    API_URL: process.env.REACT_APP_API_URL
}

export default ENV;